import {
  Box,
  Button,
  Flex,
  FormControl
} from '@chakra-ui/react'
import type { PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { padLeft } from 'BrokerTsLib/src/helpers/global'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { useContext } from 'react'

import { SelectFormControl } from 'BrokerTsLib/src/components'
import { useFindCompany } from 'BrokerTsLib/src/hooks'
import { FormGroup } from '../components/FormGroup'
import { FormLabel } from '../components/FormLabel'
import { FormSpacer } from '../components/FormSpacer'
import { InputGroup } from '../components/InputGroup'
import { useSelections } from '../hooks'
import { useNameof } from '../hooks/useNameof'
import { Cloud } from '../icons'
import { insuranceParamsContext } from '../layouts/Wizard'
import { InsureeName } from './InsureeName'


export const ICOOptions = ({ personPrefix, disabled, showAgent, hideIc }: { personPrefix: string, disabled?: boolean, showAgent?: boolean, hideIc?: boolean }) => {
  const { insuranceParams } = useContext(insuranceParamsContext)
  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const isDisabled = isContracted || disabled

  const pnameof = useNameof<PersonAdditionalData>(personPrefix)
  const { register, watch, getFieldState, setValue, trigger, control } = useFormContext()
  const { data: dataTitles, isLoading: isLoadingTitles, isFetching: isFetchingTitles } = useSelections(SelectionType.TitleBefore)

  const icPath = pnameof(x => x.idendificationNumber)
  const cnPath = pnameof(x => x.companyName)

  const ic = watch(icPath)
  const showIc = !hideIc

  const { mutateAsync: loadAres, isLoading } = useFindCompany()

  const fillCompanyData = () => {
    loadAres(ic).then((ares: PersonAdditionalData) => {
      if (ares) {
        setValue(cnPath, ares.companyName)
        setValue(pnameof(x => x.idendificationNumber), ares.idendificationNumber)
        setValue(pnameof(x => x.agent?.name), ares.agent?.name)
        setValue(pnameof(x => x.agent?.surname), ares.agent?.surname)
        setValue(pnameof(x => x.agent?.titleBefore), ares.agent?.titleBefore)
        setValue(pnameof(x => x.address.addressPoint), ares.address.addressPoint)
        setValue(pnameof(x => x.address.city), ares.address.city)
        setValue(pnameof(x => x.address.country), ares.address.country)
        setValue(pnameof(x => x.address.isEvidenceNumber), ares.address.isEvidenceNumber)
        setValue(pnameof(x => x.address.postCode), ares.address.postCode)
        setValue(pnameof(x => x.address.street), ares.address.street)
        setValue(pnameof(x => x.address.streetNumber), ares.address.streetNumber)
        setValue(pnameof(x => x.email), ares.email)
        setValue(pnameof(x => x.mobilePhone), ares.mobilePhone)
        setValue(pnameof(x => x.phone), ares.phone)
        trigger(cnPath)
      }
    })
  }

  return (
    <Box sx={{ display: 'grid', gap: 1 }}>
      <Flex>
        <FormGroup>

          <Flex sx={{ columnGap: 8, rowGap: 2, flexWrap: 'wrap', alignItems: 'start' }}>

            {showIc &&
              <FormControl isInvalid={!!getFieldState(icPath).error} isRequired>
                <FormLabel htmlFor="bcn">
                  IČO
                </FormLabel>

                <InputGroup
                  isDisabled={isDisabled}
                  id="bcn"
                  placeholder="Např. 18628443"
                  htmlSize={16}
                  errors={getFieldState(icPath).error}
                  {...register(icPath, {
                    onBlur: (e: any) => {
                      const val = e.target.value
                      setValue(icPath, val ? padLeft(val, 8, '0') : null) // doplneni zleva nulama
                    }
                  })}
                />
              </FormControl>
            }

            <FormControl isInvalid={!!getFieldState(cnPath).error} isRequired>
              <FormLabel htmlFor="bcn">
                Název firmy
              </FormLabel>

              <InputGroup
                isDisabled={isDisabled}
                id="bcn"
                htmlSize={16}
                errors={getFieldState(cnPath).error}
                {...register(cnPath)}
              />
            </FormControl>

            {showIc &&
              <FormControl>
                <FormLabel>&nbsp;</FormLabel>

                {!isDisabled &&
                  <Button
                    type="button"
                    variant="outline"
                    isLoading={isLoading}
                    isDisabled={isLoading || !ic}
                    onClick={fillCompanyData}>
                    <Cloud color="secondary.500" />
                    Načíst údaje
                  </Button>
                }
              </FormControl>
            }
          </Flex>
        </FormGroup>

      </Flex>

      {showAgent /*&& type == Selection.Company*/ &&
        < Box display='grid'>
          <FormSpacer />
          <FormSpacer />
          <FormLabel fontWeight='bold'>Jednatel / zástupce</FormLabel>
          <FormSpacer />

          <FormGroup>
            <SelectFormControl
              label="Titul před jménem"
              control={control}
              name='agent.titleBefore'
              isDisabled={isContracted}
              isLoading={isLoadingTitles || isFetchingTitles}
              unselectedText='Vyberte'
              options={dataTitles?.map((item) => ({ label: item.value!, value: item.value!.toString() })) || []}
            />

            <InsureeName personPrefix={pnameof(x => x.agent)} isDisabled={isContracted} />
          </FormGroup>
        </Box>
      }
    </Box >
  )
}